
import AnimationOverlay from '~/components/core/AnimationOverlay';

export default {
  components: { AnimationOverlay },
  props: {
    title: "",
    shortDesc: "",
    titleSpacing: {
      type: String,
      default: "mb-3"
    },
    subTitle: {
      type: String,
      default: ""
    },
    hideBreadCrumb:{
      type: Boolean,
      default: false
    }
  }

}

